(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Payment Breakdown Link Func: ", $scope, element, attrs);
    $scope.editable = attrs.editable === 'false' ? false : true;
  }

  var controllerFunction = function($scope, UserSession,$state) {
    // console.log("Payment Breakdown Controller Func: ", $scope);
    $scope.wcmContent = wcmContent;
    $scope.addNew = localStorage.getItem('transactionMode') === 'ADD';
    $scope.isAutopayWithZero = function() {
      return UserSession.accountData.currentBalance == 0 && UserSession.paymentType == 'auto';
    }
    $scope.getNextPaymentDate = function() {
      // TODO: Figure out logic when Schedule is "Immediate" (UserSession.autoPay.schedule==0);
      return moment().date(UserSession.autoPay.schedule).add(1, "M").format("MMM D, YYYY");
    };

    $scope.editMop = function(mop) {
      var dest = mop.payment.method == "CHECK" ? "edit-bank-account-info" : "edit-payment-card-info"
      $state.go(dest, { 'mopid': mop.paymentMethodId  ,'editMode': true });
    };
  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/paymentBreakdown/paymentBreakdown.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "userSession", "$state"];
  angular.module('cvsApp').directive('paymentBreakdown', directiveFunction);


})();
